import { IQuery } from 'core-ts-types';
import { IDatasource, Query } from 'utility-ts-orm';
import { PathItem } from './../builders/path_item_builder';
import { PathTask } from './../builders/path_task_builder';
import { PathTopic } from './../builders/path_topic_builder';

export interface IToDo {
  task: PathTask;
  item: PathItem;
  topic?: PathTopic;
}

export class ToDoBuilderServant {
  constructor(
    private ngPathItemDatastore: IDatasource<PathItem>,
    private ngPathTopicDatastore: IDatasource<PathTopic>,
    private EventCategoryEnum: any
  ) {}

  public buildTodo(task: PathTask): IToDo {
    task.category = this.EventCategoryEnum.get(task.category);
    const topic = _.first(this.ngPathTopicDatastore.query((currentTopic) => currentTopic.id === task.topic_id));
    const item = _.first(this.ngPathItemDatastore.query((currentItem) => currentItem.id === task.item));

    return {
      task,
      item,
      topic
    };
  }
}

angular.module('data-ng-todos').service('ngToDoBuilderServant', ToDoBuilderServant);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/servants/to_do_builder_servant.ts